module.exports = __webpack_public_path__ + "media/icons/logo-58a9ab13.svg";